export enum LoginFormProps {
  IMAGE_ALT = 'Carbon one',
  HEADING = 'Welcome back',
  SUBHEADING = "Don't have an account?",
  SUBHEADING_SPAN = 'Signup',
  HELPER_TEXT = 'Forgot Password',
  BUTTON_LABEL_SUBMIT = 'Login',
  BUTTON_LABEL_BACK = 'Back',
  USER = 'user',
  EMPTY_STRING = '',
}
